import type {SearchAssetInformationDto} from '../dto';

export interface ImageEditorContextValue {
  /** Fügt ein Bild zur Bildbearbeitung hinzu. */
  addImage: (item: SearchAssetInformationDto) => void;
  /** Fügt mehrere Bilder zur Bildbearbeitung hinzu. */
  addImages: (items: SearchAssetInformationDto[]) => void;
  /** Entfernt ein Bild aus der Bildbearbeitung. */
  removeImage: (item: SearchAssetInformationDto) => void;
  /** Prüft ob ein Bild in der Bildbearbeitung enthalten ist. */
  isInImageEditor: (item: SearchAssetInformationDto) => boolean;
  /** Anzahl der Bilder in der Bildbearbeitung. */
  imageEditorCount: number;
  /** Lädt ResultItems für die Bildbearbeitung aus dem Backend */
  loadImageEditorAssets: (page?: number) => void;
  /** Gibt an, ob zur Zeit assets geladen werden */
  loading: boolean;
  /** Die Assets für die Bildbearbeitung */
  imageEditorAssets: (SearchAssetInformationDto | undefined)[];
  /** Das momentan aktive Bild */
  activeAsset: SearchAssetInformationDto | null;
  /** Setzt das momentan aktive Bild */
  setActiveAsset: (asset: SearchAssetInformationDto) => void;
}

export enum ImageQuerySchemaVersion {
  V1 = 1,
}
